import {
	faPaperPlane,
	faPhone,
	faSuitcase,
	faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "country-flag-icons/react/3x2";
import { useRef, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import "../Menu.css";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { postDataAPI } from "../utils/fetchData";
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const Employer = () => {
	const dropdownRef = useRef(null);
	const dropdownRef1 = useRef(null);
	const dropdownRef2 = useRef(null);

	const dispatch = useDispatch();

	const [isOpen, setIsOpen] = useState(false);
	const [isOpenCer, setIsOpenCer] = useState(false);
	const [isOpenDesig, setIsOpenDesig] = useState(false);

	// const [password, setPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);

	const [selectedOption, setSelectedOption] = useState("Business Type");
	const [selectedCerOption, setSelectedCerOption] = useState("Certifications");
	const [selectedDesigOption, setSelectedDesigOption] = useState("Designation");

	const initialState = {
		name: "",
		website: "",
		address: "",
		email: "",
		fullname: "",
		password: "",
		mobile: "",
		businesstype: "",
		certification: "",
		designation: "",
	};
	const [userData, setUserData] = useState(initialState);
	const [errors, setErrors] = useState({});
	const lengthOfText = 200; // Set max length to 200

	const toggleDropdown = () => {
		setIsOpen(!isOpen);
	};

	const toggleDropdownCer = () => {
		setIsOpenCer(!isOpenCer);
	};

	const toggleDropdownDesig = () => {
		setIsOpenDesig(!isOpenDesig);
	};

	const handleOptionClick = (option) => {
		setSelectedOption(option);
		setUserData({ ...userData, businesstype: option });
		setIsOpen(false);
	};

	const handleOptionCerClick = (option) => {
		setSelectedCerOption(option);
		setUserData({ ...userData, certification: option });
		setIsOpenCer(false);
	};

	const handleOptionDesigClick = (option) => {
		setSelectedDesigOption(option);
		setUserData({ ...userData, designation: option });
		setIsOpenDesig(false);
	};

	const handlePhoneChange = (value) => {
		setUserData({ ...userData, mobile: value });
	};

	const handleChangeInput = (e) => {
		const { name, value } = e.target;
		setUserData({ ...userData, [name]: value });
	};

	const handlePasswordChange = (e) => {
		const value = e.target.value;
		// setPassword(value);
		setUserData({ ...userData, password: value });
	};

	const validateForm = () => {
		const newErrors = {};

		if (!userData.name) {
			newErrors.name = "Name is required.";
		}

		if (!userData.website) {
			newErrors.website = "Website is required.";
		}

		if (!userData.address) {
			newErrors.address = "Industry is required.";
		}

		if (!userData.fullname) {
			newErrors.fullname = "Full name is required.";
		}

		if (!userData.email) {
			newErrors.email = "Email is required.";
		} else if (!/\S+@\S+\.\S+/.test(userData.email)) {
			newErrors.emailInvalid = "Email is invalid.";
		}

		if (!userData.password) {
			newErrors.password = "Password is required.";
		} else if (
			!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(
				userData.password
			)
		) {
			newErrors.passwordInvalid =
				"Password should contain at least one uppercase, lowercase, number, special character, and be at least 8 characters long.";
		}

		if (!userData.mobile) {
			newErrors.mobile = "Mobile number is required.";
		}

		if (userData.businesstype === "") {
			newErrors.businesstype = "Business Type is required.";
		}
		// console.log(userData.certification);
		if (userData.certification === "") {
			newErrors.certification = "Certification is required.";
		}
		if (userData.designation === "") {
			newErrors.designation = "Designation is required.";
		}

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleRegister = async () => {
		if (!validateForm()) return;

		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });

		try {
			const res = await postDataAPI("createemployer", {
				...userData,
				organisationname: userData.name,
				employername: userData.fullname,
			});
			if (res.status === 200) {
				alert("Thank you for registering");
				window.location.href = "./employerlogin";
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
			dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
		}
	};

	return (
		<>
			<Navbar />
			<Homecarousel />
			<div className="emp">
				<div className="emp-box">
					<div>
						<h4>
							To access the job seekers profiles you need to Register or If you
							are already registered <a href="/employerlogin"> Login Here!</a>
						</h4>
					</div>
					<br />
					<div className="emp-heading">
						<h2>Employer Registration</h2>
					</div>
					<div className="emp-boxIn">
						<div className="emp-greenbox">
							<div>
								<h4 className="emp-greenbox-heading">
									1. Organization information
								</h4>
							</div>
							<div>
								<div className="emp-inputbox">
									<span className="emp-inputbox-input">
										<input
											type="text"
											onChange={handleChangeInput}
											placeholder="Name"
											name="name"
											maxLength={lengthOfText}
										/>
									</span>
									<div className="emp-Icon">
										<FontAwesomeIcon icon={faUser} />
									</div>
								</div>
								<p
									style={{
										visibility: errors.name ? "visible" : "hidden",
									}}
									className="error-message">
									Name is required
								</p>
								<div className="js-inputbox">
									<span className="js-inputbox-input">
										<div className="js-dropdown-container" ref={dropdownRef}>
											<div className="js-dropdown">
												<div
													className="js-dropdown-header"
													onClick={toggleDropdown}>
													{selectedOption}
													<span
														className={`js-dropdown-symbol ${
															isOpen ? "open" : ""
														}`}
													/>
												</div>

												{isOpen && (
													<ul className="js-dropdown-list">
														{[
															"Business Type",
															"Agriculture",
															"Food Processing",
															"Food Retail",
															"Food Export",
															"Certification Body",
															"Others",
														].map((option, index) => (
															<li
																key={index}
																className="js-dropdown-item"
																onClick={() => handleOptionClick(option)}>
																{option}
															</li>
														))}
													</ul>
												)}
											</div>
										</div>
									</span>
									<div className="js-Icon">
										<FontAwesomeIcon icon={faSuitcase} />
									</div>
								</div>
								<p
									style={{
										visibility: errors.businesstype ? "visible" : "hidden",
									}}
									className="error-message">
									Business Type is required
								</p>

								<div className="emp-inputbox">
									<span className="emp-inputbox-input">
										<input
											type="text"
											onChange={handleChangeInput}
											placeholder="Employer Website"
											name="website"
										/>
									</span>
									<div className="emp-Icon">
										<FontAwesomeIcon icon={faPaperPlane} />
									</div>
								</div>
								<p
									style={{
										visibility: errors.website ? "visible" : "hidden",
									}}
									className="error-message">
									Website is required
								</p>

								<div className="emp-inputbox">
									<span className="emp-inputbox-input">
										<input
											type="text"
											onChange={handleChangeInput}
											placeholder="Industry"
											name="address"
										/>
									</span>
									<div className="emp-Icon">
										<FontAwesomeIcon icon={faUser} />
									</div>
								</div>
								<p
									style={{
										visibility: errors.address ? "visible" : "hidden",
									}}
									className="error-message">
									Address is required
								</p>
								<div className="js-inputbox">
									<span className="js-inputbox-input">
										<div className="js-dropdown-container" ref={dropdownRef1}>
											<div className="js-dropdown">
												<div
													className="js-dropdown-header"
													onClick={toggleDropdownCer}>
													{selectedCerOption}
													<span
														className={`js-dropdown-symbol ${
															isOpenCer ? "open" : ""
														}`}
													/>
												</div>

												{isOpenCer && (
													<ul className="js-dropdown-list">
														{[
															"Certifications",
															"GlobalG.A.P. USDA Organic",
															"Organic NPOP",
															"ISO 22000",
															"FSSC 22000",
															"Others",
														].map((option, index) => (
															<li
																key={index}
																className="js-dropdown-item"
																onClick={() => handleOptionCerClick(option)}>
																{option}
															</li>
														))}
													</ul>
												)}
											</div>
										</div>
									</span>
									<div className="js-Icon">
										<FontAwesomeIcon icon={faSuitcase} />
									</div>
								</div>

								<div>
									<p
										style={{
											visibility: errors.certification ? "visible" : "hidden",
										}}
										className="error-message">
										Certification is required
									</p>
									<h4 className="emp-greenbox-heading">
										2. Primary Contact Information
									</h4>
								</div>

								<div className="emp-inputbox">
									<span className="emp-inputbox-input">
										<input
											onChange={handleChangeInput}
											type="text"
											placeholder="Full Name"
											name="fullname"
										/>
									</span>
									<div className="emp-Icon">
										<FontAwesomeIcon icon={faUser} />
									</div>
								</div>
								<p
									style={{
										visibility: errors.fullname ? "visible" : "hidden",
									}}
									className="error-message">
									Full name is required
								</p>
								<div className="js-inputbox">
									<span className="js-inputbox-input">
										<div className="js-dropdown-container" ref={dropdownRef2}>
											<div className="js-dropdown">
												<div
													className="js-dropdown-header"
													onClick={toggleDropdownDesig}>
													{selectedDesigOption}
													<span
														className={`js-dropdown-symbol ${
															isOpenDesig ? "open" : ""
														}`}
													/>
												</div>

												{isOpenDesig && (
													<ul className="js-dropdown-list">
														{["Designation", "CEO", "HR Manager"].map(
															(option, index) => (
																<li
																	key={index}
																	className="js-dropdown-item"
																	onClick={() =>
																		handleOptionDesigClick(option)
																	}>
																	{option}
																</li>
															)
														)}
													</ul>
												)}
											</div>
										</div>
									</span>
									<div className="js-Icon">
										<FontAwesomeIcon icon={faSuitcase} />
									</div>
								</div>
								<p
									style={{
										visibility: errors.designation ? "visible" : "hidden",
									}}
									className="error-message">
									Designation is required
								</p>

								<div className="emp-inputbox">
									<span className="emp-inputbox-input">
										<input
											type="text"
											onChange={handleChangeInput}
											placeholder="Email"
											name="email"
										/>
									</span>
									<div className="emp-Icon">
										<FontAwesomeIcon icon={faPaperPlane} />
									</div>
								</div>
								<p
									className="error-message"
									style={{
										visibility:
											errors.email || errors.emailInvalid
												? "visible"
												: "hidden",
									}}>
									{errors.email ? errors.email : errors.emailInvalid}
									{!errors.email && !errors.emailInvalid && "Text"}
								</p>
								<div className="emp-inputbox">
									<span className="js-inputbox-input">
										<input
											placeholder="Password"
											autoComplete="off"
											type={showPassword ? "text" : "password"}
											onChange={handlePasswordChange}
										/>
									</span>
									<div
										className="toggle-password d-flex align-items-center emp-Icon"
										onClick={() => setShowPassword(!showPassword)}>
										{showPassword ? (
											<>
												<FaEyeSlash className="me-1" />
											</>
										) : (
											<>
												<FaEye className="me-1" />
											</>
										)}
									</div>
								</div>
								<p
									className="error-message"
									style={{
										visibility:
											errors.password || errors.passwordInvalid
												? "visible"
												: "hidden",
									}}>
									{errors.password ? errors.password : errors.passwordInvalid}
									{!errors.password && !errors.passwordInvalid && "Text"}
								</p>
								<div className="emp-inputbox">
									<span className="emp-inputbox-input">
										<PhoneInput
											country={"in"} // Default country
											value={userData.mobile}
											onChange={handlePhoneChange}
											inputStyle={{
												width: "100%",
											}}
										/>
									</span>
									<div className="emp-Icon">
										<FontAwesomeIcon icon={faPhone} />
									</div>
								</div>
								<p
									style={{
										visibility: errors.mobile ? "visible" : "hidden",
									}}
									className="error-message">
									Mobile is required
								</p>
								<button onClick={handleRegister} className="emp-submitbtn">
									SUBMIT
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default Employer;
